"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = require("./style");
var _AnimationWrapper = require("../AnimationWrapper");
var _animations = require("../style/animations");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Notification(_ref) {
  let {
    text,
    onClose,
    type,
    action,
    secondaryAction
  } = _ref;
  const {
    AnimationWrapper,
    dismiss: dismissAnimationWrapper,
    animationProps
  } = (0, _AnimationWrapper.useAnimation)({
    justify: 'flex-end',
    stageInAnimation: _animations.stageInTop,
    stageOutAnimation: _animations.fadeOut,
    onDismiss: onClose
  });
  return /*#__PURE__*/_react.default.createElement(AnimationWrapper, Object.assign({}, animationProps), /*#__PURE__*/_react.default.createElement(_style.Container, null, /*#__PURE__*/_react.default.createElement(_style.TextRow, null, /*#__PURE__*/_react.default.createElement(_style.Text, null, text), /*#__PURE__*/_react.default.createElement(_style.Icon, {
    onClick: () => dismissAnimationWrapper()
  })), type === 'action' && ( /*#__PURE__*/_react.default.createElement(_style.ButtonsRow, null, action && ( /*#__PURE__*/_react.default.createElement(_style.ButtonStyled, {
    onClick: action.callback,
    label: action.label,
    type: "text"
  })), secondaryAction && ( /*#__PURE__*/_react.default.createElement(_style.ButtonStyled, {
    onClick: secondaryAction.callback,
    label: secondaryAction.label,
    type: "text"
  }))))));
}
Notification.propTypes = {
  text: _propTypes.default.string.isRequired,
  onClose: _propTypes.default.func.isRequired,
  type: _propTypes.default.oneOf(['action', 'text']),
  action: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    disabled: _propTypes.default.bool,
    callback: _propTypes.default.func
  }),
  secondaryAction: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    disabled: _propTypes.default.bool,
    callback: _propTypes.default.func
  })
};
Notification.defaultProps = {
  type: 'text',
  action: undefined,
  secondaryAction: undefined
};
var _default = exports.default = Notification;